const USER_PREFIX = 'FO_';

export const FETCH_FO_DETAIL_SUCCESS = USER_PREFIX + 'FETCH_FO_DETAIL_SUCCESS';
export const REMOVE_HIDDEN_SMART_CARD = USER_PREFIX + 'REMOVE_HIDDEN_SMART_CARD';
export const RESTORE_SMART_CARD = USER_PREFIX + 'RESTORE_SMART_CARD';
export const CLEAR_REMOVE_HIDDEN_SMART_CARD = USER_PREFIX + 'CLEAR_REMOVE_HIDDEN_SMART_CARD';
export const FETCH_SAVED_REPORT_SUCCESS =
  USER_PREFIX + 'FETCH_SAVED_REPORT_SUCCESS';
export const FETCH_DEFAULT_METRIC_SUCCESS =
  USER_PREFIX + 'FETCH_DEFAULT_METRIC_SUCCESS';

export const SAVE_MY_METRIC_SUCCESS = USER_PREFIX + 'SAVE_MY_METRIC_SUCCESS';
export const FETCH_MY_METRIC_SUCCESS = USER_PREFIX + 'FETCH_MY_METRIC_SUCCESS';
export const SET_SMART_CARDS_DISMISSED_LOCAL = USER_PREFIX + 'SET_SMART_CARDS_DISMISSED_LOCAL';

export const FETCH_REPORT_STANDARD_SUCCESS =
  USER_PREFIX + 'FETCH_REPORT_STANDARD_SUCCESS';
export const FETCH_REPORT_STANDARD_REQUEST =
  USER_PREFIX + 'FETCH_REPORT_STANDARD_REQUEST';
export const FETCH_REPORT_STANDARD_FAILURE =
  USER_PREFIX + 'FETCH_REPORT_STANDARD_FAILURE';
export const FETCH_REPORT_SMART_SUCCESS =
  USER_PREFIX + 'FETCH_REPORT_SMART_SUCCESS';
export const FETCH_REPORT_CUSTOM_REQUEST =
  USER_PREFIX + 'FETCH_REPORT_CUSTOM_REQUEST';
export const FETCH_REPORT_CUSTOM_FAILURE =
  USER_PREFIX + 'FETCH_REPORT_CUSTOM_FAILURE';
export const FETCH_REPORT_CUSTOM_SUCCESS =
  USER_PREFIX + 'FETCH_REPORT_CUSTOM_SUCCESS';
export const FETCH_REPORT_EXPLORER_REQUEST =
  USER_PREFIX + 'FETCH_REPORT_EXPLORER_REQUEST';
export const FETCH_REPORT_EXPLORER_FAILURE =
  USER_PREFIX + 'FETCH_REPORT_EXPLORER_FAILURE';
export const FETCH_REPORT_EXPLORER_SUCCESS =
  USER_PREFIX + 'FETCH_REPORT_EXPLORER_SUCCESS';
export const FETCH_REPORT_EXCLUSIVE_REQUEST =
  USER_PREFIX + 'FETCH_REPORT_EXCLUSIVE_REQUEST';
export const FETCH_REPORT_EXCLUSIVE_FAILURE =
  USER_PREFIX + 'FETCH_REPORT_EXCLUSIVE_FAILURE';
export const FETCH_REPORT_EXCLUSIVE_SUCCESS =
  USER_PREFIX + 'FETCH_REPORT_EXCLUSIVE_SUCCESS';

export const FETCH_INSPECTION_SUCCESS =
  USER_PREFIX + 'FETCH_INSPECTION_SUCCESS';

export const FETCH_ALL_DISPLAY_TEXT_SUCCESS =
  USER_PREFIX + 'FETCH_ALL_DISPLAY_TEXT_SUCCESS';

export const FETCH_REPORT_TO_DELETE_SUCCESS = USER_PREFIX + 'FETCH_REPORT_TO_DELETE_SUCCESS';

export const OPEN_REPORT_VIEWER_REQUEST =
  USER_PREFIX + 'OPEN_REPORT_VIEWER_REQUEST';
export const CLOSE_REPORT_VIEWER_REQUEST =
  USER_PREFIX + 'CLOSE_REPORT_VIEWER_REQUEST';

export const FILTER_SUCCESS = USER_PREFIX + 'FILTER_SUCCESS';
export const SORT_SUCCESS = USER_PREFIX + 'SORT_SUCCESS';

export const FETCH_REPORT_TAGS = USER_PREFIX + 'FETCH_REPORT_TAGS';

export const REPORT_DEFAULT_SETTING_REFRESH =
  USER_PREFIX + 'REPORT_DEFAULT_SETTING_REFRESH';

export const OPEN_GLOBAL_CONFIG_REQUEST =
  USER_PREFIX + 'OPEN_GLOBAL_CONFIG_REQUEST';

// Local-only state update to avoid list churn/race conditions when toggling favorites.
export const SET_REPORT_FAVORITED_LOCAL = USER_PREFIX + 'SET_REPORT_FAVORITED_LOCAL';

export const RESET_REPORT_ORIGIN_COMPONENT = USER_PREFIX + 'RESET_REPORT_ORIGIN_COMPONENT';
export const FETCH_AVAILABLE_DATE_BOUNDS_SUCCESS =
  USER_PREFIX + 'FETCH_AVAILABLE_DATE_BOUNDS_SUCCESS';
export const CLEAR_AVAILABLE_DATE_BOUNDS_CACHE =
  USER_PREFIX + 'CLEAR_AVAILABLE_DATE_BOUNDS_CACHE';
export const SET_TIME_WINDOW_DATES =
  USER_PREFIX + 'SET_TIME_WINDOW_DATES';

export const FETCH_GLOBAL_FILTER_OPTIONS_REQUEST =
  USER_PREFIX + 'FETCH_GLOBAL_FILTER_OPTIONS_REQUEST';
export const FETCH_GLOBAL_FILTER_OPTIONS_SUCCESS =
  USER_PREFIX + 'FETCH_GLOBAL_FILTER_OPTIONS_SUCCESS';
export const FETCH_GLOBAL_FILTER_OPTIONS_FAILURE =
  USER_PREFIX + 'FETCH_GLOBAL_FILTER_OPTIONS_FAILURE';
export const FETCH_GLOBAL_FILTER_OPTIONS_CANCELED =
  USER_PREFIX + 'FETCH_GLOBAL_FILTER_OPTIONS_CANCELED';
export const RESET_GLOBAL_FILTER_OPTIONS =
  USER_PREFIX + 'RESET_GLOBAL_FILTER_OPTIONS';

export const FETCH_COHORT_OPTIONS_SUCCESS =
  USER_PREFIX + 'FETCH_COHORT_OPTIONS_SUCCESS';
export const SET_SMART_CARD_DISMISSED_LOCAL = USER_PREFIX + 'SET_SMART_CARD_DISMISSED_LOCAL';
export const SET_SMART_CARD_PENDING = USER_PREFIX + 'SET_SMART_CARD_PENDING';

export const UPDATE_SMART_CARD_VDS_VALUES = USER_PREFIX + 'UPDATE_SMART_CARD_VDS_VALUES';
export const CACHE_SMART_CARD_VDS_VALUES = USER_PREFIX + 'CACHE_SMART_CARD_VDS_VALUES';
export const SET_SMART_CARD_VDS_LOADING = USER_PREFIX + 'SET_SMART_CARD_VDS_LOADING';

export const HIDE_SMART_CARD_REQUEST = USER_PREFIX + 'HIDE_SMART_CARD_REQUEST';
export const HIDE_SMART_CARD_FAILURE = USER_PREFIX + 'HIDE_SMART_CARD_FAILURE';
